import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import { ICustomersModalItem } from '../../types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { modalStore } from 'src/mobx/modalStore';
import { ICustomersModalParams } from 'src/mobx/modalStore/types';
import Icon from 'src/view/components/Controls/Icon/Icon';

interface IProps extends ICustomersModalParams {
  className?: string;
  titleClassName?: string;
  iconSize?: number;
}

const CustomersModalOpen: FC<IProps> = observer((props: IProps): JSX.Element => {
  const alreadySelectedUnavailableCustomers = useMemo((): ICustomersModalItem[] | null => {
    return props.selectedCustomers?.filter((customer) => customer.is_delete) || null;
  }, [props.selectedCustomers]);

  const placeholder = useMemo((): string => {
    const availableCustomersSelectedLength: number = (props.selectedCustomers?.length || 0) - (alreadySelectedUnavailableCustomers?.length || 0);
    const firstAvailableSelected: ICustomersModalItem | null = props.selectedCustomers?.find((customer) => !customer.is_delete) || null;

    switch (true) {
      case !props.selectedCustomers?.length:
        return `${localeStore.t('all')} ${localeStore.t('selected')}`;
      case Boolean(availableCustomersSelectedLength === 1 && firstAvailableSelected):
        return firstAvailableSelected?.name || firstAvailableSelected?.mobile || '';
      case Boolean(availableCustomersSelectedLength):
        return `${availableCustomersSelectedLength} ${localeStore.t('selected')}`;
      default:
        return props.isMulti ? localeStore.t('select_customers') : localeStore.t('select_customer');
    }
  }, [alreadySelectedUnavailableCustomers, props.isMulti, props.selectedCustomers]);

  const onOpen = () => {
    modalStore.openCustomersModal({
      selectedCustomers: props.selectedCustomers,
      onSave: props.onSave,
      onClose: props.onClose,
      isMulti: props.isMulti,
    });
  };

  return (
    <div className={`custom-modal__open ${props.className || ''}`} onClick={onOpen}>
      <p className={`family-medium text-size-16 color-dark ${props.titleClassName || ''}`}>{placeholder}</p>
      <Icon name={Icons.Chevron} size={props.iconSize || 20} className="color-gray2" />
    </div>
  );
});

export default CustomersModalOpen;
